<script setup lang="ts">
export type BlogArticlePanelProps = {
  variant: string
}

const props = defineProps<BlogArticlePanelProps>()

const currentComponent = computed(() => {
  switch (props.variant) {
    case 'relatedArticles':
      return resolveComponent('RelatedBlogArticlePanel')
    case 'articleList':
      return resolveComponent('BlogArticleList')
    case 'featuredArticles':
      return resolveComponent('FeaturedBlogArticlePanel')
    default:
      return null
  }
})
</script>
<template>
  <component :is="currentComponent" v-bind="{ ...$props, ...$attrs, variant }" />
</template>
